function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { roterPre } from '@/settings';
import { mapGetters } from 'vuex';
import { repeatCheckApi, saveAttendanceGroup, rosterCycleListApi, deleteGroupListApi, attendanceGroupDetailsApi, putAttendanceGroup, repeatCheckMemberApi } from '@/api/config';
export default {
  name: 'newAttendance',
  components: {
    mapContainer: function mapContainer() {
      return import('@/components/common/mapContainer');
    },
    addCycle: function addCycle() {
      return import('./components/addCycle');
    },
    selectDepartment: function selectDepartment() {
      return import('@/components/form-common/select-department');
    },
    selectMember: function selectMember() {
      return import('@/components/form-common/select-member');
    },
    shiftList: function shiftList() {
      return import('./components/shiftList');
    },
    notJoin: function notJoin() {
      return import('./components/notJoin');
    }
  },
  computed: _objectSpread({}, mapGetters(['userInfo'])),
  data: function data() {
    return {
      disabledList: [],
      type: 'add',
      from: {
        name: '',
        type: '1',
        members: [],
        // 考勤人员
        shifts: [],
        // 考勤班次
        admins: [],
        // 考勤管理员
        other_filters: [],
        // 其他考勤组排除人员
        filters: [],
        // 考勤组排除人员
        step: 'one',
        lng: 108.781332,
        lat: 34.333884,
        effective_range: 1000,
        address: '陕西省咸阳市秦都区上林街道西咸大厦',
        location_name: '西咸大厦',
        repair_allowed: true,
        //允许补卡
        repair_type: ['1', '2', '3', '4', '5'],
        // 补卡类型
        is_limit_time: true,
        // 限制补卡时间
        limit_time: 30,
        is_limit_number: true,
        limit_number: 3,
        is_photo: true,
        is_external: true,
        is_external_note: true,
        is_external_photo: true
      },
      shiftsList: [],
      // 选中班次列表
      userList: [],
      // 考勤组成员
      adminList: [],
      // 选择管理员
      filterList: [],
      // 排除管理员
      frames: [],
      // 考勤组部门
      listObj: [],
      eliminateList: [],
      // 获取未参加考勤组人员
      val: '',
      id: 0,
      activeIndex: 1,
      checkList: ['缺卡', ''],
      tableData: [],
      selectedFn: []
    };
  },
  created: function created() {
    var _this = this;
    if (this.$route.query.id) {
      this.type = 'edit';
      this.id = this.$route.query.id;
      this.getDateils();
    } else {
      // this.repeatCheckMember()
      this.type = 'add';
      var data = [];
      data.push(this.userInfo.card);
      if (data.length > 0) {
        data.map(function (item) {
          var val = {
            name: item.name,
            avatar: item.avatar,
            id: item.id
          };
          _this.adminList.push(val);
        });
      }
    }
  },
  methods: {
    otherFiltersFn: function otherFiltersFn(data) {
      this.from.other_filters = data;
    },
    // 获取部门人员禁用名单
    repeatCheckMember: function repeatCheckMember() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var data, result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              data = {
                type: _this2.from.type,
                filter_id: _this2.id
              };
              _context.next = 3;
              return repeatCheckMemberApi(data);
            case 3:
              result = _context.sent;
              _this2.disabledList = result.data;
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // 获取详情
    getDateils: function getDateils() {
      var _this3 = this;
      attendanceGroupDetailsApi(this.id).then(function (res) {
        _this3.from.name = res.data.name;
        _this3.from.type = res.data.type + '';
        _this3.repeatCheckMember();
        if (res.data.admins) {
          res.data.admins.map(function (item) {
            var val = {
              name: item.name,
              avatar: item.avatar,
              value: item.id
            };
            _this3.adminList.push(val);
          });
        }
        if (_this3.from.type == 0) {
          res.data.members.map(function (item) {
            var val = {
              name: item.name,
              avatar: item.avatar,
              value: item.id
            };
            _this3.userList.push(val);
          });
        } else {
          res.data.members.map(function (item) {
            var val = {
              name: item.name,
              avatar: item.avatar,
              id: item.id
            };
            _this3.frames.push(val);
          });
        }
        if (res.data.filters) {
          res.data.filters.map(function (item) {
            var val = {
              name: item.name,
              avatar: item.avatar,
              value: item.id
            };
            _this3.filterList.push(val);
          });
        }
        _this3.from.lng = res.data.lng;
        _this3.from.lat = res.data.lat;
        _this3.from.effective_range = res.data.effective_range;
        _this3.from.address = res.data.address;
        _this3.from.location_name = res.data.location_name;
        _this3.shiftsList = res.data.shifts;
        _this3.from.is_external = res.data.is_external == 1 ? true : false;
        _this3.from.is_external_note = res.data.is_external_note == 1 ? true : false;
        _this3.from.is_external_photo = res.data.is_external_photo == 1 ? true : false;
        _this3.from.is_limit_number = res.data.is_limit_number == 1 ? true : false;
        _this3.from.is_limit_time = res.data.is_limit_time == 1 ? true : false;
        _this3.from.is_photo = res.data.is_photo == 1 ? true : false;
        _this3.from.limit_number = res.data.limit_number;
        _this3.from.limit_time = res.data.limit_time;
        var members = [];
        members = res.data.members.map(function (item) {
          return item.id;
        });
        repeatCheckApi({
          members: members,
          type: res.data.type,
          id: _this3.id ? _this3.id : 0
        }).then(function (res) {
          _this3.eliminateList = res.data;
        });
        _this3.arrToObj();
      });
    },
    // 格式化
    formatFn: function formatFn() {
      this.from.is_external = this.from.is_external == 1 ? true : false;
      this.from.is_external_note = this.from.is_external_note == 1 ? true : false;
      this.from.is_external_photo = this.from.is_external_photo == 1 ? true : false;
      this.from.is_limit_number = this.from.is_limit_number == 1 ? true : false;
      this.from.is_limit_time = this.from.is_limit_time == 1 ? true : false;
      this.from.is_photo = this.from.is_photo == 1 ? true : false;
      this.from.repair_allowed = this.from.repair_allowed == 1 ? true : false;
    },
    // 返回
    backFn: function backFn() {
      this.$router.push({
        path: "".concat(roterPre, "/hr/attendance/setting/team")
      });
    },
    // 选中考勤班次
    selected: function selected(data) {
      this.shiftsList = data;
    },
    // 选中地图
    selectMap: function selectMap(data) {
      this.from.address = data.address;
      // this.from.effective_range = data.effective_range
      this.from.lat = data.lat;
      this.from.lng = data.lng;
    },
    nextStep: function nextStep() {
      var _this4 = this;
      if (this.activeIndex == 1) {
        if (this.frames.length !== 0 && this.from.type == '1') {
          this.frames.map(function (item) {
            _this4.from.members.push(item.id);
          });
        }
        if (this.userList.length !== 0 && this.from.type == '0') {
          this.userList.map(function (item) {
            _this4.from.members.push(item.value);
          });
        }
        if (this.adminList.length !== 0) {
          this.adminList.map(function (item) {
            _this4.from.admins.push(item.value);
          });
        }
        if (this.shiftsList.length !== 0) this.shiftsList.map(function (item) {
          _this4.from.shifts.push(item.id);
        });
        var set = new Set(this.from.shifts);
        this.from.shifts = Array.from(set);
        if (!this.from.name) return this.$message.error('请输入考勤组名称');
        if (this.from.members.length == 0) return this.$message.error('请选择需要考勤的人员或者部门');
        if (this.from.admins.length == 0) return this.$message.error('请选择需要考勤组的管理人员');
        this.filterList.map(function (item) {
          _this4.from.filters.push(item.value);
        });
        this.from.step = 'one';
        this.saveFn(this.from);
      } else if (this.activeIndex == 2) {
        this.from.step = 'two';
        this.saveFn(this.from);
      } else if (this.activeIndex == 3) {
        this.from.is_photo = this.from.is_photo ? 1 : 0;
        this.from.is_external = this.from.is_external ? 1 : 0;
        this.from.repair_allowed = this.from.repair_allowed ? 1 : 0;
        this.from.is_limit_time = this.from.is_limit_time ? 1 : 0;
        this.from.is_limit_number = this.from.is_limit_number ? 1 : 0;
        this.from.is_external_note = this.from.is_external_note ? 1 : 0;
        this.from.is_external_photo = this.from.is_external_photo ? 1 : 0;
        this.from.step = 'three';
        this.saveFn(this.from);
        this.getCycleList();
        this.formatFn();
      }
    },
    // 保存接口
    saveFn: function saveFn(data) {
      var _this5 = this;
      if (this.activeIndex == 1 && this.type == 'add') {
        saveAttendanceGroup(data).then(function (res) {
          _this5.id = res.data.id;
          _this5.activeIndex = _this5.activeIndex + 1;
        });
      } else {
        putAttendanceGroup(this.id, data).then(function (res) {
          _this5.activeIndex = _this5.activeIndex + 1;
        });
      }
    },
    // 打开考勤班次弹窗
    openShift: function openShift() {
      this.$refs.shiftList.openBox(this.shiftsList);
    },
    // 打开排班周期弹窗
    addCycleFn: function addCycleFn() {
      this.$refs.addCycle.openBox(this.id, 'add');
    },
    // 获取排班周期列表
    getCycleList: function getCycleList() {
      var _this6 = this;
      rosterCycleListApi(this.id).then(function (res) {
        if (res.status == 200) {
          _this6.tableData = res.data;
        } else {
          _this6.tableData = [];
        }
      });
    },
    // 编辑排班周期
    editFn: function editFn(data) {
      this.$refs.addCycle.openBox(data, 'edit');
    },
    deleteFn: function deleteFn(val) {
      var _this7 = this;
      this.$modalSure('你确定要删除这条数据吗').then(function () {
        deleteGroupListApi(val.id).then(function (res) {
          _this7.getCycleList();
        });
      });
    },
    // 打开未参与考勤组弹窗
    openJoin: function openJoin() {
      // let data = {
      //   type: this.from.type,
      //   filter_id: this.id
      // }
      this.$refs.notJoin.openBox(this.eliminateList);
    },
    // 保存
    submit: function submit() {
      this.backFn();
    },
    // 选择部门完成回调
    changeMastart: function changeMastart(data) {
      var _this8 = this;
      var fromData = {};
      var member = [];
      this.frames = data;
      fromData.type = this.from.type;
      this.frames.map(function (item) {
        member.push(item.id);
      });
      fromData.members = member;
      fromData.id = this.id ? this.id : 0;
      repeatCheckApi(fromData).then(function (res) {
        _this8.eliminateList = res.data;
      });
    },
    // 选择成员回调
    getSelectList: function getSelectList(data, type) {
      var _this9 = this;
      var fromData = {};
      var member = [];
      if (type === 3) {
        this.userList = data;
        this.userList.map(function (item) {
          member.push(item.value);
        });
        fromData.type = this.from.type;
        fromData.members = member;
        fromData.id = this.id ? this.id : 0;
        repeatCheckApi(fromData).then(function (res) {
          _this9.eliminateList = res.data;
        });
      } else if (type === 1) {
        this.adminList = data;
      } else if (type === 2) {
        this.filterList = data;
        this.filterList.map(function (item) {
          _this9.from.filters.push(item.value);
        });
      }
    },
    handleActiveDepartment: function handleActiveDepartment() {
      if (this.isEdit == 0) {
        return this.activeDepartment;
      } else if (this.isEdit == 1) {
        return this.activeMastart;
      } else {
        return {};
      }
    },
    close: function close() {
      this.activeDepartment = null;
      this.openStatus = false;
    },
    // 数组转对象
    arrToObj: function arrToObj() {
      var obj = {};
      this.frames.forEach(function (el, index) {
        obj[el.id] = el;
      });
      this.activeDepartment = obj;
    }
  }
};